import { defineComponent as _defineComponent } from 'vue';
import { cn } from 'Components/primitives/utils';
import { Label } from 'Components/primitives/label';
import { useFormField } from "./useFormField";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormLabel',
    props: {
        for: { type: String, required: false },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const { error, formItemId } = useFormField();
        const __returned__ = { props, error, formItemId, get cn() { return cn; }, get Label() { return Label; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
